import { boxShadows } from '@eversports/design-tokens/box-shadows'
import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Box from '@eversports/klimt-primitives/legacy/Box'

import { useIntl } from '../../../../../localization/react'
import type { Image } from '../../../VenueProfile.types'
import PlaceholderImage from '../assets/gallery-placeholder-image.webp'

import { customBreakpoints } from './Gallery.constants'

interface Props {
  idx: number
  onClick: () => void
  image?: Image
}

const GalleryImage = ({ image, idx, onClick: handleClick }: Props) => {
  const theme = useTheme()
  const intl = useIntl()

  // We just know that this breakpoint represents a specific larger size where we need to render a second main image
  const isCustomBreakpoint6 = useMediaQuery(theme.breakpoints.up(customBreakpoints.CUSTOM_BREAKPOINT_6))
  const isCustomBreakpoint7 = useMediaQuery(theme.breakpoints.up(customBreakpoints.CUSTOM_BREAKPOINT_7))

  const isMainImage = idx === 0 || ((isCustomBreakpoint6 || isCustomBreakpoint7) && idx === 1)
  const imgUrl = isMainImage ? image?.xLarge : (image?.small ?? undefined)
  const canViewImage = Boolean(imgUrl)

  return (
    <Box
      onClick={canViewImage ? handleClick : null}
      sx={{
        borderRadius: 1,
        overflow: 'hidden',
        cursor: canViewImage ? 'pointer' : 'default',
        '&:hover': { boxShadow: canViewImage ? boxShadows.hover : 'default' },
        backgroundColor: 'lightgray',
      }}
    >
      <img
        src={imgUrl ?? PlaceholderImage}
        alt={intl.venueGalleryImageAltText({ orderNumber: idx + 1 })}
        loading="eager"
        width="100%"
        height="100%"
        style={{ objectFit: 'cover', height: '100%' }}
      />
    </Box>
  )
}

export default GalleryImage
